<template>
  <div v-if="mapShow" class="MapStyleConfiger">
    <span class="p-name">地图样式</span>
    <el-select
      size="mini"
      @change="handleChange"
      v-model="curreentBorderName"
      placeholder="请选择样式"
      popper-class="MapStyleConfiger"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
  <!-- <div v-else class="MapStyleConfiger">
    <span>地图样式</span>
    <el-select
      size="mini"
      @change="handleChange"
      v-model="curreentBorderName"
      placeholder="请选择样式"
      popper-class="MapStyleConfiger"
    >
      <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select> -->
  <!-- </div> -->
</template>
<script>
export default {
  name: 'MapStyleConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      mapShow: false,
      // options1: [
      //   {
      //     value: '0',
      //     label: '默认原画',
      //   },
      // ],
      options: [
        {
          value: '0',
          label: '默认原画',
        },
        {
          value: '1',
          label: '无尽深夜',
        },
        {
          value: '2',
          label: '白路深夜',
        },
        {
          value: '3',
          label: '红水白日',
        },
        {
          value: '4',
          label: '俯视卫星',
        },
        {
          value: '5',
          label: '清新简风',
        },
        {
          value: '6',
          label: '棕色地带',
        },
        {
          value: '7',
          label: '丛林青图',
        },
      ],
      curreentBorderName: '',
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    /* 获取初始值 */
  },
  watch: {
    propertyData: {
      deep: true,
      handler: function (nV) {
        if (nV.mapType.value.maptype == 2) {
          this.mapShow = true;
        } else {
          this.mapShow = false;
          // this.handleChange(0);
        }
      },
    },
  },
  methods: {
    initData() {
      if (this.CurrentConfigration.propertyData.mapType.value.maptype == 2) {
        this.mapShow = true;
      }
      this.curreentBorderName = this.CurrentConfigration.propertyData.MapGisStyle.value.gisStyleName;
    },
    handleChange(val) {
      let sendVal = {
        gisStyleName: val,
      };
      this.commitCurrentPropertyData(sendVal);
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.MapStyleConfiger {
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    display: inline-block;
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }

  :deep().el-input input {
    color: #ffffff;
    font-size: 12px;
    background: #191b23;
    text-align: center;
    border: 1px solid rgba(139, 139, 139, 0.733);
    border-radius: 0;
    &:hover {
      border: 1px solid #3179ff;
    }
    &:focus {
      border: 1px solid #3179ff;
    }
  }
}
</style>
